var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dropdown" }, [
    _c("label", { staticClass: "filter-item-title" }, [
      _vm._v(_vm._s(_vm.label)),
    ]),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.referenceTestInput,
          expression: "referenceTestInput",
        },
      ],
      staticClass: "filter-item-content w-100",
      staticStyle: { padding: "0.5rem" },
      attrs: { type: "text", placeholder: _vm.label },
      domProps: { value: _vm.referenceTestInput },
      on: {
        click: function ($event) {
          _vm.isDropdownOpen = true
        },
        focusout: function ($event) {
          _vm.isDropdownOpen = false
        },
        input: function ($event) {
          if ($event.target.composing) return
          _vm.referenceTestInput = $event.target.value
        },
      },
    }),
    _vm._v(" "),
    _vm.isDropdownOpen && _vm.filteredOptions.length > 0
      ? _c(
          "ul",
          {
            staticClass:
              "z-3 position-absolute dropdown-list filter-item-content w-100",
            staticStyle: { "z-index": "9" },
          },
          _vm._l(_vm.filteredOptions, function (rowName, index) {
            return _c(
              "li",
              {
                key: index,
                on: {
                  mousedown: function ($event) {
                    $event.preventDefault()
                    return _vm.selectOption(rowName)
                  },
                },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t(`${_vm.tradPath}.${rowName}`)) +
                    "\n    "
                ),
              ]
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }